import { getGridSignificanceRowKey, GRID_SEGMENT_ACCESSOR } from './gridSignificanceAdapter';
import styles from '../../../utilities/significanceColumns.module.scss';

const renderDefaultCell = (value) => (value === undefined ? '' : value);

export const applyGridSignificanceColumns = ({ columns, significance }) => {
  if (!significance || !columns?.length) return columns;
  const { cellHigherThanByKey, optionAccessors, rowLetterByKey } = significance;

  return columns.map((column) => {
    if (column.accessor === GRID_SEGMENT_ACCESSOR) {
      const originalCell = column.Cell;
      return {
        ...column,
        Cell: (cellProps) => {
          const base = originalCell ? originalCell(cellProps) : renderDefaultCell(cellProps?.value);
          const letter = rowLetterByKey?.[getGridSignificanceRowKey(cellProps?.row?.original)];
          if (!letter) return base;
          return (
            <span className={styles['significance-cell']}>
              <span
                aria-label={`significance letter ${letter}`}
                className={styles['significance-letter-lead']}
                data-letters={`(${letter})`}
                data-testid="grid-significance-segment-letter"
              />
              {base}
            </span>
          );
        },
      };
    }

    if (!optionAccessors.includes(column.accessor)) return column;

    const originalCell = column.Cell;
    const lettersFor = (rowOriginal) =>
      cellHigherThanByKey?.[getGridSignificanceRowKey(rowOriginal)]?.[column.accessor] ?? [];

    return {
      ...column,
      Cell: (cellProps) => {
        const base = originalCell ? originalCell(cellProps) : renderDefaultCell(cellProps?.value);
        const letters = lettersFor(cellProps?.row?.original);
        if (!letters.length) return base;
        return (
          <span className={styles['significance-cell']}>
            {base}
            <sup
              aria-label={`significantly higher than ${letters.join(', ')}`}
              className={styles['significance-letters']}
              data-letters={letters.join(letters.some((l) => l.length > 1) ? ' ' : '')}
              data-testid="grid-significance-letters"
            />
          </span>
        );
      },
      getCellHighlight: ({ row }) => (lettersFor(row).length ? 'success' : undefined),
    };
  });
};
